import { render, staticRenderFns } from "./CompanyRegistration.vue?vue&type=template&id=51ebabe4&scoped=true&"
import script from "./CompanyRegistration.vue?vue&type=script&lang=js&"
export * from "./CompanyRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ebabe4",
  null
  
)

export default component.exports